export enum CaseLevel1Code {
  FlawNotification = 752560000,
  Notification = 752560001,
  Inquiry = 752560002,
  Reservation = 752560003,
}

export enum CaseLevel2Code {
  Heating = 752560000,
  Water = 752560001,
  Air = 752560002,
  Electricity = 752560003,
  Building = 752560004,
  Machines = 752560005,
  Outdoors = 752560006,
  Indoors = 752560007,
  WarrantyRepair = 752560008,
  Reclamation = 752560009,
  Disturbance = 752560010,
  Idea = 752560011,
  ResidentChanges = 752560012,
  MeterReadings = 752560013,
  Management = 752560014,
  Board = 752560015,
  Finance = 752560016,
  Balance = 752560017,
  Loans = 752560018,
  ParkingLot = 752560019,
  Garage = 752560020,
  Sauna = 752560021,
  OtherSpace = 752560022,
  Other = 752560023,
}

export enum CaseLevel3Code {
  PM = 752560000,
  Maintenance = 752560001,
  Cleaning = 752560002,
  Disposal = 752560003,
  GeneralMeeting = 752560004,
  DevelopmentIdea = 752560005,
  NameTagChange = 752560006,
  NameChange = 752560007,
  NumberOfResidents = 752560008,
  Receivables = 752560009,
  Prepayments = 752560010,
  PayingLoan = 752560011,
  LoanReport = 752560012,
  Reservation = 752560013,
  EndingContract = 752560014,
  Inquiry = 752560015,
  GreenAreas = 752560016,
  WinterMaintenance = 752560017,
  Other = 752560018,
}
